import { LinkButton, useAnalytics } from "../../components";
import { UiDownloadButtonModel } from "../../models";
import { MapModelToProps } from "../../utils";

export type UiDownloadButtonProps = MapModelToProps<UiDownloadButtonModel>;

const UiDownloadButton = ({ model }: UiDownloadButtonProps) => {
    const { sendTrackEvent } = useAnalytics();
    const {
        entryTitle,
        text,
        buttonTheme,
        mediaAsset: { url }
    } = model.content;
    const theme = buttonTheme?.content ? { ...buttonTheme.content } : {};
    const props = {
        onClick: () =>
            sendTrackEvent("clickedUiDownloadButton", {
                event: "clicked",
                eventComponent: "button",
                eventContainer: "content",
                label: text,
                labelEnglish: entryTitle,
                uuid: model.id,
                href: url,
                theme
            }),
        url,
        ...theme
    };
    return (
        <LinkButton {...props} data-uuid={model.id}>
            {text}
        </LinkButton>
    );
};

export default UiDownloadButton;
